import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Charge from payment method',
    [BillingMode.InternalInvoicing]: 'Charge from sales',
    active: 'Active',
    on_trial: 'On trial',
    launch_pending: 'On hold until launch date',
    billing_disabled: 'Billing disabled',
    on_grace_period: 'On grace period',
    past_due: 'Past due',
    cancelled: 'Cancelled',
  },
};
